import { Adapter as r } from "../../../adapter.js";
import { TicketDeliveryModel as p } from "./ticketDelivery.model.js";
class i extends r {
  adapt(e) {
    return new p({
      pickUpAddress: e.pick_up_address,
      pickUpName: e.pick_up_name,
      pickUpPhoneNumber: e.pick_up_phone_number,
      pickUpAt: e.pick_up_at,
      dropOffAddress: e.drop_off_address,
      dropOffAddressLatitude: e.drop_off_address_latitude,
      dropOffAddressLongitude: e.drop_off_address_longitude,
      dropOffAt: e.drop_off_at,
      dropOffNotes: e.drop_off_notes,
      assignedDeliveryOperators: e.assigned_delivery_operators
    });
  }
  serialize(e) {
  }
}
export {
  i as TicketDeliveryAdapter
};
//# sourceMappingURL=ticketDelivery.adapter.js.map
